/* Zailarah - Shop the Look: the outfit picker used by the outfit drawer (sections/zl-outfits.liquid) and the outfit
   page (sections/main-outfit.liquid). Data: snippets/zl-outfit-json.liquid, texts: snippets/zl-outfit-strings.liquid.
   Every piece is an original product: its colours are its sibling products, its sizes are their variants, and the bag
   receives each selected piece as its own variant (window.ZL.cart.add, or /cart/add.js when the cart client is missing).
   Plain ES2019, no dependencies. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('zl-outfit-page')) return;
  var win = window, doc = document;

  function zl() { return win.ZL || {}; }
  function money(c) { var z = zl(); return z.money ? z.money(c) : (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(t, o) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return k in o ? o[k] : m; }); }
  function parse(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function same(a, b) { if (a.length !== b.length) return false; for (var i = 0; i < a.length; i++) if (String(a[i]) !== String(b[i])) return false; return true; }

  /* ------------------------------------------------------------------ picker */

  function Picker(root, data, T, opts) {
    this.root = root; this.data = data; this.T = T || {}; this.opts = opts || {};
    this.state = (data.items || []).map(function (it) {
      var st = { ci: 0, sel: [], on: true };
      var c = it.colours[0];
      var v = firstAvailable(c);
      st.sel = (v || c.variants[0] || { options: [] }).options.slice();
      st.on = Boolean(v);
      return st;
    });
    this.render();
  }

  function firstAvailable(c) {
    for (var i = 0; i < c.variants.length; i++) if (c.variants[i].available) return c.variants[i];
    return null;
  }

  Picker.prototype.colour = function (i) { var it = this.data.items[i]; return it.colours[this.state[i].ci] || it.colours[0]; };
  Picker.prototype.variant = function (i) {
    var c = this.colour(i), sel = this.state[i].sel;
    for (var k = 0; k < c.variants.length; k++) if (same(c.variants[k].options, sel)) return c.variants[k];
    return null;
  };
  /* sold-out marker for an option value, given the other chosen values */
  Picker.prototype.valueAvailable = function (i, k, value) {
    var c = this.colour(i), sel = this.state[i].sel.slice();
    sel[k] = value;
    for (var n = 0; n < c.variants.length; n++) if (c.variants[n].available && same(c.variants[n].options, sel)) return true;
    return false;
  };

  /* option values short enough for buttons (sizes); long lists or long names use a dropdown */
  function asPills(vals) { return vals.length <= 8 && vals.every(function (v) { return String(v).length <= 12; }); }

  Picker.prototype.itemHTML = function (i) {
    var self = this, T = this.T, st = this.state[i], it = this.data.items[i], c = this.colour(i);
    var n = this.data.items.length;
    var h = '<li class="zlo-item' + (st.on ? '' : ' is-off') + '" data-i="' + i + '">';
    h += '<div class="zlo-item__media"><a class="zlo-item__img" href="' + esc(c.url) + '" tabindex="-1">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy" width="240" height="360">' : '') + '</a>' +
      '<span class="zlo-item__num">' + (i + 1) + '/' + n + '</span></div>';
    h += '<div class="zlo-item__main"><div class="zlo-item__head"><a class="zlo-item__name" href="' + esc(c.url) + '">' + esc(c.title) + '</a><p class="zlo-item__price" data-price></p></div>';
    if (it.colours.length > 1) {
      h += '<div class="zlo-opt"><p class="zlo-opt__label">' + esc(T.colour) + ' <b>' + esc(c.colour) + '</b></p><div class="zlo-sw" role="group" aria-label="' + esc(T.colour) + '">';
      it.colours.forEach(function (oc, j) {
        var bg = oc.hex ? ' style="background:' + esc(oc.hex) + '"' : '';
        h += '<button type="button" class="zlo-sw__b' + (oc.hex ? '' : ' zlo-sw__b--img') + '" data-colour="' + j + '" aria-pressed="' + (j === st.ci) + '" title="' + esc(oc.colour) + '"' + bg + '>' +
          (oc.hex ? '' : (oc.img ? '<img src="' + esc(oc.img) + '" alt="">' : '')) + '<span class="zlo-sr">' + esc(oc.colour) + '</span></button>';
      });
      h += '</div></div>';
    }
    var chart = this.opts.charts && this.opts.charts[i];
    var chartShown = false;
    (c.options || []).forEach(function (name, k) {
      var vals = [];
      c.variants.forEach(function (v) { if (vals.indexOf(v.options[k]) < 0) vals.push(v.options[k]); });
      if (vals.length === 1 && /^default title$/i.test(vals[0])) return;
      h += '<div class="zlo-opt"><p class="zlo-opt__label">' + esc(name) + (vals.length > 1 ? ' <b>' + esc(st.sel[k]) + '</b>' : ' <b>' + esc(vals[0]) + '</b>');
      if (chart && !chartShown) { h += '<button type="button" class="zlo-opt__guide" data-guide aria-expanded="' + Boolean(st.chart) + '">' + esc(T.sizeGuide || 'Size guide') + '</button>'; chartShown = true; }
      h += '</p>';
      if (vals.length > 1) {
        if (asPills(vals)) {
          h += '<div class="zlo-pills" role="group" aria-label="' + esc(name) + '">';
          vals.forEach(function (val) {
            var ok = self.valueAvailable(i, k, val), on = String(st.sel[k]) === String(val);
            h += '<button type="button" class="zlo-pill' + (ok ? '' : ' is-out') + '" data-opt="' + k + '" data-val="' + esc(val) + '" aria-pressed="' + on + '"' + (ok ? '' : ' title="' + esc(T.soldOut) + '"') + '>' + esc(val) + '</button>';
          });
          h += '</div>';
        } else {
          h += '<select class="zlo-select" data-opt="' + k + '" aria-label="' + esc(name) + '">';
          vals.forEach(function (val) {
            var ok = self.valueAvailable(i, k, val);
            h += '<option value="' + esc(val) + '"' + (String(st.sel[k]) === String(val) ? ' selected' : '') + '>' + esc(val) + (ok ? '' : ' - ' + esc(T.soldOut)) + '</option>';
          });
          h += '</select>';
        }
      }
      h += '</div>';
    });
    if (chart) h += '<div class="zlo-chart"' + (st.chart ? '' : ' hidden') + ' data-chart>' + chart + '</div>';
    h += '<p class="zlo-item__status" data-status></p>';
    h += '<div class="zlo-item__actions">';
    h += '<button type="button" class="zlo-item__toggle" data-toggle aria-pressed="' + st.on + '">' + esc(st.on ? (T.remove || 'Remove from look') : (T.include || 'Add back to look')) + '</button>';
    if (this.opts.single) h += '<button type="button" class="zlo-item__add" data-add-one>' + esc(T.addOne) + '</button>';
    return h + '</div></div></li>';
  };

  Picker.prototype.render = function () {
    var h = '<ul class="zlo-items">';
    for (var i = 0; i < this.data.items.length; i++) h += this.itemHTML(i);
    h += '</ul><div class="zlo-foot"><p class="zlo-pair" data-pair hidden></p><div class="zlo-total"><span><span>' + esc(this.T.total) + '</span><small data-count></small></span><b data-total></b></div>' +
      '<button type="button" class="zl-btn zl-btn--solid zlo-addall" data-add-all></button>' +
      '<p class="zlo-msg" role="status" aria-live="polite" data-msg></p>';
    if (this.opts.view && this.data.url && this.T.view) h += '<a class="zlo-view" href="' + esc(this.data.url) + '">' + esc(this.T.view) + '</a>';
    this.root.innerHTML = h + '</div>';
    this.bind();
    this.update();
  };

  Picker.prototype.rerenderItem = function (i) {
    var li = this.root.querySelector('.zlo-item[data-i="' + i + '"]');
    if (!li) return;
    var tmp = doc.createElement('ul');
    tmp.innerHTML = this.itemHTML(i);
    li.parentNode.replaceChild(tmp.firstChild, li);
    this.update();
  };

  Picker.prototype.bind = function () {
    var self = this;
    if (this.bound) return;
    this.bound = true;
    this.root.addEventListener('change', function (e) {
      var li = e.target.closest('.zlo-item');
      if (!li || !e.target.matches('select[data-opt]')) return;
      var i = Number(li.getAttribute('data-i'));
      self.state[i].sel[Number(e.target.getAttribute('data-opt'))] = e.target.value;
      self.rerenderItem(i);
    });
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-colour],[data-add-all],[data-add-one],[data-val],[data-toggle],[data-guide]');
      if (!b || !self.root.contains(b)) return;
      if (b.hasAttribute('data-add-all')) { self.addSelected(b); return; }
      var li = b.closest('.zlo-item'), i = Number(li.getAttribute('data-i')), st = self.state[i];
      if (b.hasAttribute('data-add-one')) { var v = self.variant(i); if (v && v.available) self.add([{ id: v.id, quantity: 1 }], b); return; }
      if (b.hasAttribute('data-guide')) {
        st.chart = !st.chart;
        var ch = li.querySelector('[data-chart]');
        if (ch) ch.hidden = !st.chart;
        b.setAttribute('aria-expanded', String(st.chart));
        return;
      }
      if (b.hasAttribute('data-toggle')) {
        var cur = self.variant(i);
        if (!st.on && !(cur && cur.available)) return;
        st.on = !st.on;
        self.rerenderItem(i);
        return;
      }
      if (b.hasAttribute('data-val')) {
        st.sel[Number(b.getAttribute('data-opt'))] = b.getAttribute('data-val');
        var nv = self.variant(i);
        if (nv && nv.available) st.on = true;
        self.rerenderItem(i);
        return;
      }
      self.pickColour(i, Number(b.getAttribute('data-colour')));
    });
  };

  /* new colour: keep the chosen size when that colour has it in stock, otherwise its first available variant */
  Picker.prototype.pickColour = function (i, j) {
    var st = this.state[i], old = this.colour(i), oldSel = st.sel.slice();
    st.ci = j;
    var c = this.colour(i), keep = null;
    c.variants.forEach(function (v) {
      if (keep || !v.available) return;
      var ok = true;
      v.options.forEach(function (val, k) { var n = c.options[k]; var ok2 = old.options.indexOf(n); if (ok2 > -1 && String(oldSel[ok2]) !== String(val)) ok = false; });
      if (ok) keep = v;
    });
    var v = keep || firstAvailable(c) || c.variants[0];
    st.sel = v ? v.options.slice() : [];
    if (v && v.available) st.on = true;
    this.rerenderItem(i);
  };

  Picker.prototype.update = function () {
    var T = this.T, total = 0, n = 0, all = true, len = this.data.items.length;
    for (var i = 0; i < len; i++) {
      var li = this.root.querySelector('.zlo-item[data-i="' + i + '"]');
      var v = this.variant(i), st = this.state[i], ok = Boolean(v && v.available);
      if (li) {
        var p = li.querySelector('[data-price]'), s = li.querySelector('[data-status]'), one = li.querySelector('[data-add-one]'), tg = li.querySelector('[data-toggle]');
        if (p) p.innerHTML = v ? esc(money(v.price)) + (v.compare > v.price ? ' <s>' + esc(money(v.compare)) + '</s>' : '') : '';
        if (s) { s.textContent = ok ? '' : T.soldOut; s.classList.toggle('is-out', !ok); }
        if (one) one.disabled = !ok;
        if (tg) tg.disabled = !ok && !st.on;
        li.classList.toggle('is-off', !(st.on && ok));
      }
      if (st.on && ok) { total += v.price; n++; } else all = false;
    }
    var tEl = this.root.querySelector('[data-total]'), btn = this.root.querySelector('[data-add-all]'), cnt = this.root.querySelector('[data-count]');
    /* pair discount (display of the shop's automatic discount): only when every piece is in, in its original colour */
    var pct = Number(this.data.pct) || 0, pair = pct > 0 && all && n === len, pEl = this.root.querySelector('[data-pair]');
    for (var q = 0; pair && q < len; q++) if (this.state[q].ci !== 0) pair = false;
    var shown = pair ? Math.round(total * (100 - pct) / 100) : total;
    if (tEl) tEl.innerHTML = pair ? '<s>' + esc(money(total)) + '</s> ' + esc(money(shown)) : esc(money(total));
    if (pEl) {
      pEl.hidden = pct <= 0;
      pEl.textContent = fill(pair ? (T.pair || 'Pair price −[pct]%') : (T.pairHint || 'Buy every piece and save [pct]%'), { pct: pct });
      pEl.classList.toggle('is-on', pair);
    }
    var orig = total;
    total = shown;
    if (cnt) cnt.textContent = fill(T.count || '[n] of [total] pieces', { n: n, total: len });
    if (btn) { btn.textContent = n === 0 ? T.none : (all ? T.add : fill(T.addSome, { n: n })); btn.disabled = n === 0; }
    if (this.opts.onTotal) this.opts.onTotal(total, n, pair ? orig : 0, pct);
  };

  Picker.prototype.addSelected = function (btn) {
    var items = [];
    for (var i = 0; i < this.data.items.length; i++) {
      var v = this.variant(i);
      if (this.state[i].on && v && v.available) items.push({ id: v.id, quantity: 1 });
    }
    if (!items.length) { this.msg(this.T.none); return; }
    this.add(items, btn);
  };

  Picker.prototype.msg = function (t) { var m = this.root.querySelector('[data-msg]'); if (m) m.textContent = t || ''; };

  Picker.prototype.add = function (items, btn) {
    var self = this, cart = zl().cart;
    self.msg('');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var done = function (ok, err) {
      if (btn) { btn.removeAttribute('aria-busy'); }
      self.update();
      if (!ok) { self.msg(err || self.T.error); return; }
      if (self.opts.onAdded) self.opts.onAdded();
    };
    if (cart && typeof cart.add === 'function') {
      cart.add(items, { open: true }).then(function (res) { done(res && res.ok, res && res.error); }, function () { done(false); });
      return;
    }
    var root = (zl().routes && zl().routes.root) || '/';
    fetch(root.replace(/\/?$/, '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (r) { if (!r.ok) { done(false, r.j && (r.j.description || r.j.message)); return; } win.location.href = root.replace(/\/?$/, '/') + 'cart'; }, function () { done(false); });
  };

  function strings(scope) { return parse(scope.querySelector('[data-outfit-strings]')) || {}; }

  /* ------------------------------------------------------------------ outfit page */

  class OutfitPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var data = parse(this.querySelector('[data-outfit-json]'));
      var root = this.querySelector('[data-outfit-root]');
      if (!data || !root || !(data.items || []).length) return;
      var top = doc.querySelector('[data-outfit-total-top]');
      var charts = {};
      [].forEach.call(this.querySelectorAll('template[data-outfit-chart]'), function (t) {
        var html = t.innerHTML.trim();
        if (html) charts[Number(t.getAttribute('data-outfit-chart'))] = html;
      });
      this.picker = new Picker(root, data, strings(this), {
        single: true,
        charts: charts,
        onTotal: function (t, n, was, pct) {
          if (!top) return;
          top.innerHTML = esc(money(t)) + (was ? ' <s>' + esc(money(was)) + '</s> <em>−' + pct + '%</em>' : '');
        }
      });
    }
  }

  /* ------------------------------------------------------------------ outfit drawer (collection page) */

  class OutfitDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.section = this.closest('.zlo') || doc;
      /* a transformed ancestor (reveal animations) would trap position:fixed: the drawer lives on <body> */
      if (this.parentNode !== doc.body) { this._ready = false; this._section = this.section; doc.body.appendChild(this); return; }
      if (this._section) this.section = this._section;
      this.panel = this.querySelector('.zlo-drawer__panel');
      this.body = this.querySelector('[data-outfit-root]');
      this.titleEl = this.querySelector('[data-outfit-title]');
      this.T = strings(this);
      this.section.addEventListener('click', function (e) {
        var o = e.target.closest('[data-outfit-open]');
        if (!o || self.contains(o)) return;
        var card = o.closest('.zlo-card');
        var data = card && parse(card.querySelector('[data-outfit-json]'));
        if (!data || !(data.items || []).length) return;   /* no data: the link goes to the outfit page */
        e.preventDefault();
        self.open(data, o);
      });
      this.addEventListener('click', function (e) { if (e.target.closest('[data-outfit-close]')) self.close(); });
      this._key = function (e) { if (e.key === 'Escape') self.close(); };
    }
    open(data, opener) {
      var self = this;
      this.opener = opener;
      this.titleEl.textContent = data.name || '';
      this.picker = new Picker(this.body, data, this.T, { view: true, onAdded: function () { self.close(true); } });
      this.hidden = false;
      doc.documentElement.classList.add('zlo-lock');
      requestAnimationFrame(function () { self.classList.add('is-open'); self.panel.focus({ preventScroll: true }); });
      doc.addEventListener('keydown', this._key);
    }
    close(keepFocus) {
      var self = this;
      if (this.hidden) return;
      this.classList.remove('is-open');
      doc.documentElement.classList.remove('zlo-lock');
      doc.removeEventListener('keydown', this._key);
      setTimeout(function () { self.hidden = true; self.body.innerHTML = ''; }, 300);
      if (!keepFocus && this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('zl-outfit-page')) customElements.define('zl-outfit-page', OutfitPage);
  if (!customElements.get('zl-outfit-drawer')) customElements.define('zl-outfit-drawer', OutfitDrawer);
})();
